/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const registerCreditScoreRepresentative = /* GraphQL */ `
    mutation RegisterCreditScoreRepresentative(
        $input: RegisterCreditScoreRepresentativeInput!
        $scoreProvider: String!
    ) {
        registerCreditScoreRepresentative(
            input: $input
            scoreProvider: $scoreProvider
        ) {
            authenticationCompleted
            questionaryId
            questions {
                id
                text
                options {
                    id
                    text
                }
            }
        }
    }
`
export const authenticateCreditScoreRepresentative = /* GraphQL */ `
    mutation AuthenticateCreditScoreRepresentative(
        $input: AuthenticateCreditScoreRepresentativeInput!
        $scoreProvider: String!
    ) {
        authenticateCreditScoreRepresentative(
            input: $input
            scoreProvider: $scoreProvider
        ) {
            questionaryStatus
            additionalQuestionsNeeded
        }
    }
`
export const fetchCreditScore = /* GraphQL */ `
    mutation FetchCreditScore($scoreProvider: String!) {
        fetchCreditScore(scoreProvider: $scoreProvider) {
            score
            scoreReady
        }
    }
`
export const createLoanApplicationInNode = /* GraphQL */ `
    mutation CreateLoanApplicationInNode(
        $client: InputClientMetadata
        $loan_application: InputLoanApplicationFromNode
    ) {
        createLoanApplicationInNode(
            client: $client
            loan_application: $loan_application
        ) {
            data {
                loan_application_id
                institution_id
                name
                loan_product
                status
                loan_purpose
                data {
                    prequalification_amount
                    date
                    amount
                    principal
                    interest
                    interest_rate
                    fees
                    ltv_ratio
                    iso_currency_code
                    term
                    last_updated
                }
                repayment_history {
                    repayment_id
                    amount
                    principal
                    interest
                    fees
                    iso_currency_code
                    date_due
                    date_received
                    status
                }
            }
        }
    }
`
export const updateLoanApplicationInNode = /* GraphQL */ `
    mutation UpdateLoanApplicationInNode(
        $client: InputClientMetadata
        $loan_application: InputLoanApplicationFromNode
    ) {
        updateLoanApplicationInNode(
            client: $client
            loan_application: $loan_application
        ) {
            data {
                loan_application_id
                institution_id
                name
                loan_product
                status
                loan_purpose
                data {
                    prequalification_amount
                    date
                    amount
                    principal
                    interest
                    interest_rate
                    fees
                    ltv_ratio
                    iso_currency_code
                    term
                    last_updated
                }
                repayment_history {
                    repayment_id
                    amount
                    principal
                    interest
                    fees
                    iso_currency_code
                    date_due
                    date_received
                    status
                }
            }
        }
    }
`
export const storeCredential = /* GraphQL */ `
    mutation StoreCredential($input: StoreCredentialInput!) {
        storeCredential(input: $input)
    }
`
export const fetchCryptoData = /* GraphQL */ `
    mutation FetchCryptoData {
        fetchCryptoData
    }
`
export const fetchTranasctionsBalances = /* GraphQL */ `
    mutation FetchTranasctionsBalances {
        fetchTranasctionsBalances
    }
`
export const exchangePublicToken = /* GraphQL */ `
    mutation ExchangePublicToken(
        $publicToken: String!
        $institutionData: InstitutionData!
    ) {
        exchangePublicToken(
            publicToken: $publicToken
            institutionData: $institutionData
        ) {
            balances {
                id
                userProfileId
                itemId
                balanceAvailable
                balanceCurrent
                balanceLimit
                isoCurrencyCode
                mask
                name
                officialName
                type
                subtype
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
            }
        }
    }
`
export const impactUserInterests = /* GraphQL */ `
    mutation ImpactUserInterests($input: ImpactUserInterestsInput) {
        impactUserInterests(input: $input) {
            deleted
            created
        }
    }
`
export const generateUserDataReport = /* GraphQL */ `
    mutation GenerateUserDataReport {
        generateUserDataReport
    }
`
export const transactionsExport = /* GraphQL */ `
    mutation TransactionsExport($input: TransactionsExportInput) {
        transactionsExport(input: $input)
    }
`
export const deleteUserData = /* GraphQL */ `
    mutation DeleteUserData($userId: String, $deleteType: DeleteType!) {
        deleteUserData(userId: $userId, deleteType: $deleteType)
    }
`
export const updateUserProfile = /* GraphQL */ `
    mutation UpdateUserProfile($input: UpdateUserProfileInput) {
        updateUserProfile(input: $input) {
            id
            email
            firstName
            lastName
            phone
            dateOfBirth
            countryId
            loanApplicationId
            lastLoginDate
            givenConsentDate
            removedConsentDate
            notifyEmail
            notifyPhone
            activeRole
            availableRoles
            payableAddress
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            country {
                id
                name
                abbreviation
                bankApproved
                pngmeApproved
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
            }
            loanApplication {
                id
                userProfileId
                state
                amount
                porpuse
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
            }
            interests {
                items {
                    id
                    userProfileId
                    productInterestId
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                nextToken
                startedAt
            }
        }
    }
`
export const regenerateUserData = /* GraphQL */ `
    mutation RegenerateUserData($input: RegenerateUserDataInput) {
        regenerateUserData(input: $input) {
            from
            to
            fiatConnectionsCount
            cryptoCredentialsCount
        }
    }
`
export const createProductInterest = /* GraphQL */ `
    mutation CreateProductInterest(
        $input: CreateProductInterestInput!
        $condition: ModelProductInterestConditionInput
    ) {
        createProductInterest(input: $input, condition: $condition) {
            id
            text
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
            users {
                items {
                    id
                    userProfileId
                    productInterestId
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                nextToken
                startedAt
            }
        }
    }
`
export const updateProductInterest = /* GraphQL */ `
    mutation UpdateProductInterest(
        $input: UpdateProductInterestInput!
        $condition: ModelProductInterestConditionInput
    ) {
        updateProductInterest(input: $input, condition: $condition) {
            id
            text
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
            users {
                items {
                    id
                    userProfileId
                    productInterestId
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                nextToken
                startedAt
            }
        }
    }
`
export const deleteProductInterest = /* GraphQL */ `
    mutation DeleteProductInterest(
        $input: DeleteProductInterestInput!
        $condition: ModelProductInterestConditionInput
    ) {
        deleteProductInterest(input: $input, condition: $condition) {
            id
            text
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
            users {
                items {
                    id
                    userProfileId
                    productInterestId
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                nextToken
                startedAt
            }
        }
    }
`
export const createCountry = /* GraphQL */ `
    mutation CreateCountry(
        $input: CreateCountryInput!
        $condition: ModelCountryConditionInput
    ) {
        createCountry(input: $input, condition: $condition) {
            id
            name
            abbreviation
            bankApproved
            pngmeApproved
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
        }
    }
`
export const updateCountry = /* GraphQL */ `
    mutation UpdateCountry(
        $input: UpdateCountryInput!
        $condition: ModelCountryConditionInput
    ) {
        updateCountry(input: $input, condition: $condition) {
            id
            name
            abbreviation
            bankApproved
            pngmeApproved
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
        }
    }
`
export const deleteCountry = /* GraphQL */ `
    mutation DeleteCountry(
        $input: DeleteCountryInput!
        $condition: ModelCountryConditionInput
    ) {
        deleteCountry(input: $input, condition: $condition) {
            id
            name
            abbreviation
            bankApproved
            pngmeApproved
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
        }
    }
`
export const createFeatureFlag = /* GraphQL */ `
    mutation CreateFeatureFlag(
        $input: CreateFeatureFlagInput!
        $condition: ModelFeatureFlagConditionInput
    ) {
        createFeatureFlag(input: $input, condition: $condition) {
            id
            name
            code
            enabled
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
        }
    }
`
export const updateFeatureFlag = /* GraphQL */ `
    mutation UpdateFeatureFlag(
        $input: UpdateFeatureFlagInput!
        $condition: ModelFeatureFlagConditionInput
    ) {
        updateFeatureFlag(input: $input, condition: $condition) {
            id
            name
            code
            enabled
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
        }
    }
`
export const deleteFeatureFlag = /* GraphQL */ `
    mutation DeleteFeatureFlag(
        $input: DeleteFeatureFlagInput!
        $condition: ModelFeatureFlagConditionInput
    ) {
        deleteFeatureFlag(input: $input, condition: $condition) {
            id
            name
            code
            enabled
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
        }
    }
`
export const createUserProfile = /* GraphQL */ `
    mutation CreateUserProfile(
        $input: CreateUserProfileInput!
        $condition: ModelUserProfileConditionInput
    ) {
        createUserProfile(input: $input, condition: $condition) {
            id
            email
            firstName
            lastName
            phone
            dateOfBirth
            countryId
            loanApplicationId
            lastLoginDate
            givenConsentDate
            removedConsentDate
            notifyEmail
            notifyPhone
            activeRole
            availableRoles
            payableAddress
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            country {
                id
                name
                abbreviation
                bankApproved
                pngmeApproved
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
            }
            loanApplication {
                id
                userProfileId
                state
                amount
                porpuse
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
            }
            interests {
                items {
                    id
                    userProfileId
                    productInterestId
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                nextToken
                startedAt
            }
        }
    }
`
export const createLoanApplication = /* GraphQL */ `
    mutation CreateLoanApplication(
        $input: CreateLoanApplicationInput!
        $condition: ModelLoanApplicationConditionInput
    ) {
        createLoanApplication(input: $input, condition: $condition) {
            id
            userProfileId
            state
            amount
            porpuse
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
        }
    }
`
export const updateLoanApplication = /* GraphQL */ `
    mutation UpdateLoanApplication(
        $input: UpdateLoanApplicationInput!
        $condition: ModelLoanApplicationConditionInput
    ) {
        updateLoanApplication(input: $input, condition: $condition) {
            id
            userProfileId
            state
            amount
            porpuse
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
        }
    }
`
export const deleteLoanApplication = /* GraphQL */ `
    mutation DeleteLoanApplication(
        $input: DeleteLoanApplicationInput!
        $condition: ModelLoanApplicationConditionInput
    ) {
        deleteLoanApplication(input: $input, condition: $condition) {
            id
            userProfileId
            state
            amount
            porpuse
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            owner
        }
    }
`
export const createUserProductInterest = /* GraphQL */ `
    mutation CreateUserProductInterest(
        $input: CreateUserProductInterestInput!
        $condition: ModelUserProductInterestConditionInput
    ) {
        createUserProductInterest(input: $input, condition: $condition) {
            id
            userProfileId
            productInterestId
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            productInterest {
                id
                text
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
                users {
                    nextToken
                    startedAt
                }
            }
            userProfile {
                id
                email
                firstName
                lastName
                phone
                dateOfBirth
                countryId
                loanApplicationId
                lastLoginDate
                givenConsentDate
                removedConsentDate
                notifyEmail
                notifyPhone
                activeRole
                availableRoles
                payableAddress
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                country {
                    id
                    name
                    abbreviation
                    bankApproved
                    pngmeApproved
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                loanApplication {
                    id
                    userProfileId
                    state
                    amount
                    porpuse
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                interests {
                    nextToken
                    startedAt
                }
            }
            owner
        }
    }
`
export const updateUserProductInterest = /* GraphQL */ `
    mutation UpdateUserProductInterest(
        $input: UpdateUserProductInterestInput!
        $condition: ModelUserProductInterestConditionInput
    ) {
        updateUserProductInterest(input: $input, condition: $condition) {
            id
            userProfileId
            productInterestId
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            productInterest {
                id
                text
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
                users {
                    nextToken
                    startedAt
                }
            }
            userProfile {
                id
                email
                firstName
                lastName
                phone
                dateOfBirth
                countryId
                loanApplicationId
                lastLoginDate
                givenConsentDate
                removedConsentDate
                notifyEmail
                notifyPhone
                activeRole
                availableRoles
                payableAddress
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                country {
                    id
                    name
                    abbreviation
                    bankApproved
                    pngmeApproved
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                loanApplication {
                    id
                    userProfileId
                    state
                    amount
                    porpuse
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                interests {
                    nextToken
                    startedAt
                }
            }
            owner
        }
    }
`
export const deleteUserProductInterest = /* GraphQL */ `
    mutation DeleteUserProductInterest(
        $input: DeleteUserProductInterestInput!
        $condition: ModelUserProductInterestConditionInput
    ) {
        deleteUserProductInterest(input: $input, condition: $condition) {
            id
            userProfileId
            productInterestId
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            productInterest {
                id
                text
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
                users {
                    nextToken
                    startedAt
                }
            }
            userProfile {
                id
                email
                firstName
                lastName
                phone
                dateOfBirth
                countryId
                loanApplicationId
                lastLoginDate
                givenConsentDate
                removedConsentDate
                notifyEmail
                notifyPhone
                activeRole
                availableRoles
                payableAddress
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                country {
                    id
                    name
                    abbreviation
                    bankApproved
                    pngmeApproved
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                loanApplication {
                    id
                    userProfileId
                    state
                    amount
                    porpuse
                    _version
                    _deleted
                    _lastChangedAt
                    createdOn
                    updatedOn
                    owner
                }
                interests {
                    nextToken
                    startedAt
                }
            }
            owner
        }
    }
`
